/* eslint-disable react/prop-types */
import { createContext, useState } from 'react'
import {petitions} from '../api/calls.js'

export const DataContext = createContext();

export function DataContextProvider(props) {
  const [user, setUser] = useState({})
  const [empresa, setEmpresa] = useState({})

  const saveUser = async (id,token) => {
    const response = await petitions.getUsuario(id,token)
    var rpsta = response.status === "success" ? true : false
    rpsta && setUser(response.data[0])
    return rpsta
  }

  const saveEmpresa = async (idEmpresa,token) => {
    const response = await petitions.getEmpresa(idEmpresa,token)
    response.status === "success" ? setEmpresa(response.data) : console.log(response)
  }

  const session = () => {
    return JSON.parse(localStorage.getItem("session"))
  }

  const idEmpresa = () => {
    return JSON.parse(localStorage.getItem("empresa")).value
  }

  return (
    <DataContext.Provider value={{saveUser,saveEmpresa, user, empresa , session, idEmpresa}}>
        {props.children}
    </DataContext.Provider>
  )
}